module.exports = __webpack_public_path__ + "img/icon_index_thumb_outcall_intro_3.cd912130.png";